// src/components/Footer.tsx

import React from "react";
import "../../styles/Footer.css";
import { appData } from "../../data/appData";
import { Link } from "react-router-dom";
import { useContactSettings } from "../../data/ContactSettingsContext";
import { contactSettingsToLinks } from "../../data/contactSettings";

const socialIcons = {
  Facebook: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
    </svg>
  ),
  X: <span className="x-logo">X</span>,
  LinkedIn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
    </svg>
  ),
  Instagram: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  ),
  WhatsApp: (
    // WhatsApp SVG Icon
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 448 512"
      fill="currentColor"
    >
      <path d="M380.9 97.1C339-3.8 247.5-32.3 169.5 15.5 108 54.2 69 123.5 69 198.6c0 33.1 7.5 65.2 22 95l-23.4 86.4c-2.6 9.6 6.7 18.9 16.3 16.3l86.4-23.4c29.8 14.4 61.6 21.8 94 21.8 75.1 0 144.5-39 183.1-100.6 47.9-78.2 19.3-169.8-60.5-211.6zM221.4 371c-29.2 0-57.9-7.5-83.2-21.7l-5.9-3.3-51.4 13.9 13.9-51.4-3.3-5.9c-14.3-25.3-21.7-54-21.7-83.2 0-89.4 72.7-162 162-162 89.4 0 162 72.7 162 162 .1 89.4-72.6 162-161.9 162zm97.6-116.7l-27.4-27.4c-3.5-3.5-9.1-3.5-12.6 0l-14.8 14.8c-3.5 3.5-3.5 9.1 0 12.6l11.6 11.6c3.5 3.5 3.5 9.1 0 12.6l-8.5 8.5c-3.5 3.5-9.1 3.5-12.6 0l-21.3-21.3c-3.5-3.5-3.5-9.1 0-12.6l8.5-8.5c3.5-3.5 3.5-9.1 0-12.6l-11.6-11.6c-3.5-3.5-9.1-3.5-12.6 0l-14.8 14.8c-3.5 3.5-3.5 9.1 0 12.6l27.4 27.4c18.8 18.8 49.2 18.8 68 0l29.5-29.5c18.7-18.8 18.7-49.2 0-68z" />
    </svg>
  ),
  Telegram: (
    // Telegram SVG Icon
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 496 512"
      fill="currentColor"
    >
      <path d="M248,8C111.033,8,0,119.033,0,256s111.033,248,248,248,248-111.033,248-248S384.967,8,248,8Zm114.364,160.4-49.1,233.647c-3.7,16.936-13.79,21.167-27.952,13.236L255.4,372.27,213.2,410.6c-4.487,4.487-8.216,8.216-16.844,8.216l6.032-85.047L344.8,218.1c6.547-5.671-.21-8.854-10.057-3.183L163.9,300.213l-79.8-25.042c-17.343-5.42-17.6-17.343,3.675-25.623L361.756,152.1C373.422,148.061,383.3,154.448,362.364,168.4Z" />
    </svg>
  ),
};

const Footer: React.FC = () => {
  const { settings: contactSettings } = useContactSettings();

  const currentYear = new Date().getFullYear();

  // Define the routes to exclude from the company links
  const excludedRoutes: string[] = ["/privacy", "/terms"];

  // Filter out the excluded routes from the company links
  const filteredCompanyLinks = appData.footer.companyLinks.filter(
    (link) => !excludedRoutes.includes(link.href)
  );

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Links Section
          <div className="footer-section ">
            <h4>Business ID</h4>
            <h5>2846401-8</h5>
          </div> */}
          {/* Company Links Section */}
          <div className="footer-section company-links">
            <h4>Company</h4>
            {filteredCompanyLinks.map((link, index) => (
              <Link key={index} to={link.href} aria-label={link.name}>
                {link.name}
              </Link>
            ))}
          </div>

          {/* Social Links Section */}
          <div className="footer-section social-links">
            <h4>Social</h4>
            <div className="social-links-container">
              {contactSettingsToLinks(contactSettings).filter((link) => !link.excludeFromFooter).map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  aria-label={link.name}
                  className="social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {socialIcons[
                    (link.name === "Twitter"
                      ? "X"
                      : link.name === "WhatsApp Channel"
                        ? "WhatsApp"
                        : link.name) as keyof typeof socialIcons
                  ] || link.name}
                  <span className="icon-name">{link.name}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Integrations Links Section */}
          {/* <div className="footer-section integrations-links">
            <h4>Integrations</h4>
            {appData.footer.integrationsLinks.length > 0 ? (
              appData.footer.integrationsLinks.map((link, index) => (
                <Link key={index} to={link.href} aria-label={link.name}>
                  {link.name}
                </Link>
              ))
            ) : (
              <p>Coming Soon</p> // Optional: Display a message if no integrations
            )}
          </div> */}

          {/* Legal Links Section */}
          <div className="footer-section legal-links">
            <h4>Legal</h4>
            {appData.footer.legalLinks.map((link, index) => (
              <Link key={index} to={link.href} aria-label={link.name}>
                {link.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Company Information */}
        <div className="company-info">© {currentYear} {appData.footer.copyWright}</div>

        {/* Credit Section */}
        <div className="credit">
          <p>
            Made with ❤️ by{" "}
            <a
              href="https://www.linkedin.com/in/mariusmonkam/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Marius Monkam
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
